"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Store = void 0;
const core_1 = require("../core");
const constants_1 = require("./constants");
const messages_1 = require("./messages");
const options_1 = require("./options");
const memoryStorage_1 = require("./memoryStorage");
const cookieStorage_1 = require("./cookieStorage");
class Store extends core_1.CoreBaseModule {
    constructor(options) {
        super(options_1.storeOptionsDefault, Object.assign({}, options));
        this.storage = Store.resolveStorage(this.getOptions().storage, this.getOptions().config);
        this.loaded = true;
    }
    //Store Config by now only used by cookies
    static resolveStorage(storageDefined, storeConfig) {
        let storage;
        switch (storageDefined) {
            case constants_1.StorageLocation.Local:
                storage = localStorage;
                break;
            case constants_1.StorageLocation.Session:
                storage = sessionStorage;
                break;
            case constants_1.StorageLocation.Memory:
                storage = new memoryStorage_1.MemoryStorage();
                break;
            case constants_1.StorageLocation.Cookie:
                storage = new cookieStorage_1.CookieStorage(storeConfig);
                break;
            default:
                throw Error(messages_1.StoreMessages.STORE_INVALID_STORAGE);
        }
        return storage;
    }
    setItem(key, value) {
        this.validateLoaded();
        core_1.Log.info(`[store.set]: "${key}":`, value);
        this.storage.setItem(this.getOptions().prefix + key, this.stringifyValue(value));
    }
    getItem(key) {
        this.validateLoaded();
        const value = this.storage.getItem(this.getOptions().prefix + key);
        const value2 = value === null ? undefined : value;
        const value3 = this.parseValue(value2);
        core_1.Log.info(`[store.get] "${key}":`, value3);
        return value3;
    }
    removeItem(key) {
        this.validateLoaded();
        core_1.Log.info(`[store.removeItem] "${key}"`);
        this.storage.removeItem(this.getOptions().prefix + key);
    }
    clear() {
        this.validateLoaded();
        const regExp = new RegExp(`^${this.getOptions().prefix}*`);
        let tempStore;
        if (this.getOptions().storage === constants_1.StorageLocation.Memory) {
            tempStore = Array.from(this.storage.data.keys());
        }
        else {
            tempStore = Object.keys(this.storage);
        }
        tempStore.forEach(_key => {
            if (_key.match(regExp)) {
                this.storage.removeItem(_key);
            }
        });
    }
    getLength() {
        this.validateLoaded();
        return this.storage.length;
    }
    getKey(key) {
        this.validateLoaded();
        const _key = this.storage.key(key);
        if (_key) {
            return _key.replace(new RegExp(`^${this.getOptions().prefix}`), '');
        }
        return _key;
    }
    stringifyValue(value) {
        let valueString = '';
        try {
            //only stringify if it is not a string
            if (typeof value !== 'string') {
                valueString = JSON.stringify(value);
            }
            else {
                valueString = value;
            }
            if (!this.getOptions().debug) {
                valueString = (0, core_1.b64EncodeUnicode)(valueString);
            }
        }
        catch (e) {
            /* istanbul ignore next: impossible to reproduce with UT */
            throw Error(messages_1.StoreMessages.STORE_ERROR_STRINGIFY);
        }
        return valueString;
    }
    parseValue(value) {
        if (value) {
            try {
                let valueToReturn;
                if (!this.getOptions().debug) {
                    value = (0, core_1.b64DecodeUnicode)(value);
                }
                return this.parseDecodedValue(value);
            }
            catch (e) {
                core_1.Log.error(messages_1.StoreMessages.STORE_ERROR_PARSING);
                this.clear();
            }
        }
    }
    parseDecodedValue(value) {
        try {
            return JSON.parse(value);
        }
        catch (e) {
            // JSON.parse("undefined") throws an error, and we want to return the undefined value instead of the string
            if (value === 'undefined')
                return undefined;
            // Otherwise we assume JSON.parse failed because value is already a string
            return value;
        }
    }
}
exports.Store = Store;
//# sourceMappingURL=store.js.map